import React, {useContext} from 'react';
import UserContext from '../../context/user-context';
import Spinner from '../UI/Spinner';
import { useTranslation } from 'react-i18next';
import {Link} from 'react-router-dom'

const currentMember = (props) => {
    const userContext = useContext(UserContext);
    const { t, i18n } = useTranslation();

    let html = <Spinner />;
    if (userContext.user.account
        && userContext.user.account.name
        && userContext.user.infos
    ){
        const canChangeAccount = userContext.user.infos.account_count>1;
        const originalUserId = userContext.user.infos.original_user_id;
        const personnificationAccountId = userContext.user.infos.personnification_account_id;
        const userId = userContext.user.infos.user_id;
        html =
            <div className="current-account">
                {t("header.loggedas")} <strong>{userContext.user.account.name} #{userContext.user.account.accountCode}</strong> {t("header.entantque")} {userContext.user.infos.firstname} {userContext.user.infos.lastname}
                {canChangeAccount?<Link className={"link link--accent link--red"} to="/accounts/change-account">{t("header.changeaccount")}</Link>:null} {<Link to="/accounts/change-account/add">{t("header.addaccount")}</Link>}
                {(originalUserId > 0)?<a className="link link--red" href={"/switchuser/"+originalUserId} onClick={(e)=>document.body.classList.add('reseting')}>{t("header.quit_personification")}</a>:''}
                {(!originalUserId && personnificationAccountId > 0)?<a className="link link--red" href={"/switchuser/"+userId} onClick={(e)=>document.body.classList.add('reseting')}>{t("header.quit_personification")}</a>:''}
            </div>;
    } else if (userContext.user
        && userContext.user.infos
        && userContext.user.infos.account_count>1
        && (!userContext.user.account || (userContext.user.account && !userContext.user.account.length))
    ){
        html = "";
        /*
            <div className="current-account">
                {t("header.entantque")} {userContext.user.infos.firstname} {userContext.user.infos.lastname}
            </div>;*/
    }

    return html;
}


export default currentMember;

